<template>
  <div class="m-container">
    <m_header></m_header>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">专家服务消费明细表</div>
          <span class="m-title-s">专家服务消费记录查询</span>
        </div>
        <div class="m-total-item">
          <div style="font-weight: bold;">
            业绩总额：{{ allPay }} 元
          </div>
          <div style="font-size: 12px;color: #ff2020;">未选择查询时间段时，数据均为累积总数</div>
        </div>
        <div class="m-total-item">
          <div style="font-weight: bold;">
            苹果系统业绩额：{{ iosPay }} 元
          </div>
          <div style="font-size: 12px;color: #ff2020;">未选择查询时间段时，数据均为累积总数</div>
        </div>
        <div class="m-total-item">
          <div style="font-weight: bold;">
            安卓系统业绩额：{{ androidPay }} 元
          </div>
          <div style="font-size: 12px;color: #ff2020;">未选择查询时间段时，数据均为累积总数</div>
        </div>
        <div class="m-total-time-search">
          查询时间：
          <el-date-picker
            v-model="dateArr"
            @change="onDateChange"
            type="datetimerange"
            :default-time="['00:00:00','23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <div style="margin-left: 20px;">
            <el-button type="primary" @click="playSearchData()" size="small">查询</el-button>
            <el-button type="info" @click="resetSearch" plain size="small">刷新</el-button>
          </div>
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div>
            <el-form ref="searchForm" :model="searchForm" label-width="100px" inline size="small">
              <el-form-item label="所属地区:" v-if="userType === '1'">
                <el-select v-model="searchForm.cooperatorId" placeholder="请选择所属地区" size="small" @change="cooperatorChange">
                  <el-option v-for="item in cooperatorOpt" :key="item.value" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="用户电话:">
                <el-input type="text" size="small" v-model="searchForm.phone" maxlength="11" placeholder="搜索用户电话" />
              </el-form-item>
              <el-form-item style="float: right;">
                <el-button type="primary" @click="playSearchData()" size="small">查询</el-button>
                <el-button type="info" @click="resetSearch" plain size="small">刷新</el-button>
                <el-button type="success" @click="exportSearchData" plain size="small" style="margin-left: 20px;">导出数据</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border size="small">
          <el-table-column prop="phone" label="注册电话" align="center" width="120"></el-table-column>
          <el-table-column prop="payMoney" label="商品金额(元)">
            <template slot-scope="scope">
              <div>{{scope.row.payMoney}} 元</div>
            </template>
          </el-table-column>
          <el-table-column prop="payerTotal" label="支付金额(元)">
            <template slot-scope="scope">
              <div>{{scope.row.payerTotal/100}} 元</div>
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="支付类型">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.payType === 'ios'" size="mini" type="success">苹果支付</el-tag>
              <el-tag v-if="scope.row.payType === 'aliPay' || scope.row.payType === 'wx'" size="mini" type="primary">安卓支付</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="商品名称"></el-table-column>
          <el-table-column prop="createDate" label="创建订单时间"></el-table-column>
          <el-table-column prop="payDate" label="支付时间"></el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          prev-text="上一页"
          next-text="下一页">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import excelUtil from '../utils/ExcelUtils'

export default {
  name: 'expertBuyInfo',
  data () {
    return {
      isLoading: true,
      list: [],
      exportSearchDataList: [],
      dateArr: [],
      cooperatorOpt: [],
      userType: '',
      total: 0,
      allPay: 0.00,
      iosPay: 0.00,
      androidPay: 0.00,
      searchForm: {
        phone: '',
        type: '',
        cooperatorId: '',
        startDate: '',
        endDate: '',
        pageNo: 1
      }
    }
  },
  methods: {
    useExportUtil (data) {
      const initColumn = [
        {
          title: '注册电话',
          dataIndex: 'phone',
          key: 'phone',
          className: 'text-monospace'
        },
        {
          title: '商品金额(元)',
          dataIndex: 'payMoney',
          key: 'payMoney'
        },
        {
          title: '支付金额(元)',
          dataIndex: 'payerTotal',
          key: 'payerTotal'
        },
        {
          title: '支付类型',
          dataIndex: 'payType',
          key: 'payType'
        },
        {
          title: '商品名称',
          dataIndex: 'description',
          key: 'description'
        },
        {
          title: '创建订单时间',
          dataIndex: 'createDate',
          key: 'createDate'
        },
        {
          title: '支付时间',
          dataIndex: 'payDate',
          key: 'payDate'
        }
      ]
      excelUtil.exportExcel(initColumn, data, '用户消费列表.xlsx')
    },
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.listData()
    },
    resetSearch () {
      this.searchForm = {
        phone: '',
        type: '',
        cooperatorId: '',
        startDate: '',
        endDate: '',
        pageNo: 1
      }
      this.dateArr = []
      this.listData()
      this.loadTotal()
    },
    // 执行搜索
    playSearchData () {
      this.total = 0
      this.searchForm.pageNo = 1
      this.listData()
      this.loadTotal()
    },
    // 导出当前查询条件的数据
    exportSearchData () {
      let _this = this
      if (_this.searchForm.startDate === '' || _this.searchForm.endDate === '') {
        _this.$message.error('请选择查询日期再导出数据')
        return
      }
      _this.isLoading = true
      _this.searchForm.type = this.userType
      this.$axios.post('/appUser/exportSearchDataExpertPayList', _this.searchForm)
        .then((res) => {
          if (res.data !== null) {
            if (res.data.length > 0) {
              let list = []
              for (let i = 0; i < res.data.length; i++) {
                list.push(res.data[i])
                list[i].payerTotal = (list[i].payerTotal / 100) // 转换为元单位显示
              }
              _this.useExportUtil(list) // 执行导出数据
            }
          }
          _this.exportSearchDataList = res.data
          _this.isLoading = false
        })
    },
    // 列表
    listData () {
      let _this = this
      _this.isLoading = true
      _this.searchForm.type = this.userType
      this.$axios.post('/appUser/expertPayList', _this.searchForm)
        .then((res) => {
          _this.list = []
          _this.list = res.data.rows
          _this.total = res.data.total
          _this.isLoading = false
        })
    },
    // 总数
    loadTotal () {
      let _this = this
      _this.searchForm.type = this.userType
      this.$axios.post('/appUser/userExpertPayTotal', _this.searchForm)
        .then((res) => {
          _this.allPay = res.data.allPay
          _this.iosPay = res.data.iosPay
          _this.androidPay = res.data.androidPay
        })
    },
    onDateChange (e) {
      let startDate = new Date(e[0])
      let endDate = new Date(e[1])
      this.searchForm.startDate = startDate.getFullYear() +
        '-' + (startDate.getMonth() < 10 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) +
        '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
      this.searchForm.endDate = endDate.getFullYear() +
        '-' + (endDate.getMonth() < 10 ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)) +
        '-' + (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate())
    },
    // 城市合作商下拉选项
    loadCooperatorOpt () {
      let _this = this
      this.$axios.post('/options/cooperatorOpt')
        .then((res) => {
          _this.cooperatorOpt = res.data
        })
    }
  },
  mounted () {
    if (!window.sessionStorage.user) {
      this.$router.push({name: 'login'})
    } else {
      this.userType = JSON.parse(window.sessionStorage.user).userType
    }
    this.listData()
    this.loadTotal()
    // 如果是省级合作商则加载省内城市合作商列表，否则直接加载团队长列表
    if (this.userType === '1') {
      this.loadCooperatorOpt()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/expert/expertBuyInfo.vue